import {navigationPaths} from "@/common/navigation/navigationPaths";

const enumDef = {
    language: {
        DE: "de_DE",
        EN: "en_US",

        properties: {
            "de_DE": {
                key: "common.language.de",
                abbr: "common.language.de.abbr",
                file: "locale-ge-DE.json"
            },
            "en_US": {
                key: "common.language.en",
                abbr: "common.language.en.abbr",
                file: "locale-zh-EN.json"
            }
        }
    },
    receivableType: {
        SingleInvoice: 0,
        CollectiveInvoice: 10,
        SettlementList: 20,
        TbBundle: 30,
        CreditMemo: 50,

        properties: {
            0: {
                key: "common.data.receivableType.singleInvoice",
                icon: "fa-file-text"
            },
            50: {
                key: "common.data.receivableType.creditMemo",
                icon: "fa-envelope-open"
            },
            10: {
                key: "common.data.receivableType.collectiveInvoice",
                icon: "fa-list"
            },
            20: {
                key: "common.data.receivableType.settlementList",
                icon: "fa-archive"
            },
            30: {
                key: "common.data.receivableType.bundle",
                icon: "fa-paperclip"
            },
        }
    },

    invoiceType: {
        RegistrationFee: 1,
        PostingFee: 2,
        TransactionFee: 5,
        AuctionFee: 8,
        ClosingFee: 9,
        ServiceFee: 10,
        PutOptionFee: 11,
        DebtorCheckFee: 12,
        KycCheckFee: 13,
        InsurancePremiumFees: 14,
        TnPContractFee: 15,
        CollectionFee: 16,

        properties: {
            1: {
                key: "common.data.invoiceType.registrationFee",
            },
            2: {
                key: "common.data.invoiceType.postingFee",
            },
            5: {
                key: "common.data.invoiceType.transactionFee"
            },
            8: {
                key: "common.data.invoiceType.auctionFee"
            },
            9: {
                key: "common.data.invoiceType.closingFee"
            },
            10: {
                key: "common.data.invoiceType.serviceFee"
            },
            11: {
                key: "common.data.invoiceType.putOptionFee"
            },
            12: {
                key: "common.data.invoiceType.debtorCheckFee"
            },
            13: {
                key: "common.data.invoiceType.kycCheckFee"
            },
            14: {
                key: "common.data.invoiceType.insurancePremiumFees"
            },
            15: {
                key: "common.data.invoiceType.tnpContractFee"
            },
            16: {
                key: "common.data.invoiceType.collectionFee"
            }
        },

        excludeInFilter(value) {
            let type = Number(value);
            switch (type) {
                case this.RegistrationFee:
                case this.PostingFee:
                case this.TransactionFee:
                case this.ServiceFee:
                    return true;
                default:
                    return false;
            }
        }
    },

    creditNoteType: {
        RegistrationFee: 1,
        PostingFee: 2,
        TransactionFee: 5,
        AuctionFee: 8,
        ClosingFee: 9,
        ServiceFee: 10,
        PartnerCommission: 11,
        TrustBillsTransactionCommission: 12,
        TrustBillsPutOptionCommission: 13,

        properties: {
            1: {
                key: "common.data.creditNoteType.registrationFee"
            },
            2: {
                key: "common.data.creditNoteType.postingFee"
            },
            5: {
                key: "common.data.creditNoteType.transactionFee"
            },
            8: {
                key: "common.data.creditNoteType.auctionFee"
            },
            9: {
                key: "common.data.creditNoteType.closingFee"
            },
            10: {
                key: "common.data.creditNoteType.serviceFee"
            },
            11: {
                key: "common.data.creditNoteType.partnerCommission"
            },
            12: {
                key: "common.data.creditNoteType.trustbillsCommission"
            }
        }
    },

    accountStatus: {
        Created: 5,
        Unauthorized: 0,
        CanRead: 1,
        CanReadAndWrite: 2,
        ManuallyDisabled: 4,

        properties: {
            5: {
                key: "common.data.accountStatus.created"
            },
            0: {
                key: "common.data.accountStatus.unauthorized"
            },
            1: {
                key: "common.data.accountStatus.canRead"
            },
            2: {
                key: "common.data.accountStatus.canReadAndWrite"
            },
            4: {
                key: "common.data.accountStatus.manuallyDisabled"
            }
        }
    },

    userLevel: {
        RootUser: 10,
        ManagerUser: 20,
        NormalUser: 30,

        properties: {
            10: {
                key: "common.data.userLevel.root"
            },
            20: {
                key: "common.data.userLevel.deputy"
            },
            30: {
                key: "common.data.userLevel.normal"
            }
        },

        isAdminUser(level) {
            return level !== this.NormalUser;
        }
    },

    userStatus: {
        Deleted: -100,
        DisabledByCare: -90,
        DisabledByMasterUser: -80,
        New: 0,
        Active: 2,
        EmailVerified: 1,

        isDisabled(status) {
            return status === this.DisabledByCare || status === this.DisabledByMasterUser;
        },

        properties: {
            "-100": {
                key: "common.data.userStatus.deleted"
            },
            "-90": {
                key: "common.data.userStatus.disabledByCare"
            },
            "-80": {
                key: "common.data.userStatus.disabledByMasterUser"
            },
            0: {
                key: "common.data.userStatus.new"
            },
            1: {
                key: "common.data.userStatus.emailVerified"
            },
            2: {
                key: "common.data.userStatus.active",
            }
        }
    },

    masterUserRepresentativeRelation: {
        NoPower: 0,
        SolePower: 1,
        JointPower: 2
    },

    representativeType: {
        SolePower: 1,
        JointPower: 2
    },

    bidType: {
        Bid: 10,
        InstantBuy: 20,
        RevolvingPutOption: 30,
        Alfa: 40,

        properties: {
            10: {
                key: "common.data.bidType.bid"
            },
            20: {
                key: "common.data.bidType.instantBuy"
            },
            30: {
                key: "common.data.bidType.putOption"
            },
            40: {
                key: "common.data.bidType.alfa"
            },
        }
    },

    auctionStatus: {
        New: 0,
        Public: 1,
        Selling: 2,
        Sold: 3,
        Abortive: 4,
        Canceled: 5,
        WaitingForConfirmation: 6,

        properties: {
            0: {
                key: "auction.status.new"
            },
            1: {
                key: "auction.status.StartingSoon"
            },
            2: {
                key: "auction.status.running"
            },
            3: {
                key: "auction.status.Ended"
            },
            4: {
                key: "auction.status.Expired"
            },
            5: {
                key: "auction.status.Canceled"
            },
            6: {
                key: "auction.status.WaitingForConfirmation"
            }
        }
    },

    receivableStatus: {
        InSettlement: 70,
        SettlementReceivedTransfer: 80,
        SettlementFinished: 90,
        Contested: 110
    },

    allReceivablesState: {
        Uploading: "uploading",
        Ready: "ready",
        Selling: "selling",
        WaitingForConfirmation: "waiting_for_confirmation",
        Sold: "sold",
        Unsold: "unsold",
        Canceled: "canceled",
        Repaid: "repaid",
        Unpaid: "unpaid",
        Expired: "expired",

        properties: {
            uploading: {
                key: "common.data.allReceivablesState.uploading"
            },
            ready: {
                key: "common.data.allReceivablesState.ready"
            },
            selling: {
                key: "common.data.allReceivablesState.selling"
            },
            waiting_for_confirmation: {
                key: "common.data.allReceivablesState.waitingForConfirmation"
            },
            sold: {
                key: "common.data.allReceivablesState.sold"
            },
            unsold: {
                key: "common.data.allReceivablesState.unsold"
            },
            canceled: {
                key: "common.data.allReceivablesState.canceled"
            },
            repaid: {
                key: "common.data.allReceivablesState.repaid"
            },
            unpaid: {
                key: "common.data.allReceivablesState.unpaid"
            },
            expired: {
                key: "common.data.allReceivablesState.expired"
            }
        }
    },

    debtorState: {
        Created: "created",
        InReview: "in_review",
        Verified: "verified",
        Registered: "registered",
        Deactivated: "deactivated",
        DeactivatedByPlatform: "deactivated_by_platform",
        Expired: "expired",

        properties: {
            created: {
                key: "common.data.debtorState.created"
            },
            in_review: {
                key: "common.data.debtorState.inReview"
            },
            verified: {
                key: "common.data.debtorState.verified"
            },
            registered: {
                key: "common.data.debtorState.registered"
            },
            deactivated: {
                key: "common.data.debtorState.deactivated"
            },
            deactivated_by_platform: {
                key: "common.data.debtorState.deactivatedByPlatform"
            },
            expired: {
                key: "common.data.debtorState.expired"
            },
        },
    },

    transactionType: {
        Auction: 10,
        InstantBuy: 20,
        RevolvingPutOption: 30,

        properties: {
            10: {
                key: "common.data.transactionType.auction"
            },
            20: {
                key: "common.data.transactionType.instantBuy"
            },
            30: {
                key: "common.data.transactionType.revolvingPutOption"
            }
        }
    },

    postTradeType: {
        UndisclosedUnconfirmed: 0,
        DisclosedUnconfirmed: 1,
        DisclosedConfirmed: 3,
        DisclosedConfirmedUnverified: 5,

        properties: {
            0: {
                key: "common.data.postTradeType.undisclosedUnconfirmed"
            },
            1: {
                key: "common.data.postTradeType.disclosedUnconfirmed"
            },
            3: {
                key: "common.data.postTradeType.disclosedConfirmed"
            }
        }
    },

    dunningLevel: {
        None: 0,
        FirstDunning: 10,
        SecondDunning: 20,
        DisclosureStart: 35,
        Handoverable: 60,
        Transferred: 70,

        properties: {
            0: {
                key: "",
            },
            10: {
                key: "collection.dunningLevel.overdue",
                cssClass: "overdue_badge"
            },
            20: {
                key: "collection.dunningLevel.firstDunning",
                cssClass: "first_dunning_badge"
            },
            35: {
                key: "collection.dunningLevel.secondDunning",
                cssClass: "second_dunning_badge"
            },
            60: {
                key: "collection.dunningLevel.handoverable",
                cssClass: "handoverable_badge"
            },
            70: {
                key: "collection.dunningLevel.transferred",
                cssClass: "transferred_badge"
            },
        }
    },

    insuranceStatus: {
        created: 0,
        active: 10,
        cancelled: 20,
        claimPossible: 30,
        claimSubmitted: 35,
        claimCancelled: 41,
        claimAccepted: 50,
        claimRecovered: 51,
        claimRejected: 60,
        claimPaid: 70,
        invoicePaid: 80,
        afterClaimPaid: 90,

        properties: {
            "-10": {
                key: ""
            },
            0: {
                key: "collection.insuranceStatus.created"
            },
            10: {
                key: "collection.insuranceStatus.active"
            },
            20: {
                key: "collection.insuranceStatus.cancelled"
            },
            30: {
                key: "collection.insuranceStatus.claimPossible"
            },
            35: {
                key: "collection.insuranceStatus.claimSubmitted"
            },
            41: {
                key: "collection.insuranceStatus.claimCancelled"
            },
            50: {
                key: "collection.insuranceStatus.claimAccepted"
            },
            51: {
                key: "collection.insuranceStatus.claimRecovered"
            },
            60: {
                key: "collection.insuranceStatus.claimRejected"
            },
            70: {
                key: "collection.insuranceStatus.claimPaid"
            },
            80: {
                key: "collection.insuranceStatus.invoicePaid"
            },
            90: {
                key: "collection.insuranceStatus.afterClaimPaid"
            },
        }
    },

    unpaidCaseActionStage: {
        None: 0,
        Precourt: 1,
        Court: 2,
        PaymentPlan: 3,
        Insolvency: 4,

        properties: {
            0: {
                key: ""
            },
            1: {
                key: "collection.unpaidCaseActionStage.precourt"
            },
            2: {
                key: "collection.unpaidCaseActionStage.court"
            },
            3: {
                key: "collection.unpaidCaseActionStage.paymentPlan"
            },
            4: {
                key: "collection.unpaidCaseActionStage.insolvency"
            }
        }
    },

    unpaidCaseActionReason: {
        None: 0,
        DebtorPaidToSeller: 1,
        DebtorDisputesPaymentDeadline: 2,
        DebtorRequestedDocuments: 3,
        DebtorMadePartialPayment: 4,
        DebtorDisputesClaim: 5,
        DebtorNotReachable: 6,
        Insolvency: 7,
        FinalNoticeSentByEmail: 8,
        FinalNoticeSentByPost: 9,
        Resubmission: 10,
        Others: 11,
        DebtorHasDeclaredPayment: 12,
        DebtorDoesNotAcceptFactoring: 13,
        DebtorPromisedToComeBack: 14,
        TciBankruptcy: 20,
        TciNotPaid: 21,
        TciDisputed: 22,
        TciRejected: 23,

        properties: {
            0: {
                key: ""
            },
            1: {
                key: "collection.unpaidCaseActionReason.debtorPaidToSeller"
            },
            2: {
                key: "collection.unpaidCaseActionReason.debtorDisputesPaymentDeadline"
            },
            4: {
                key: "collection.unpaidCaseActionReason.debtorMadePartialPayment"
            },
            5: {
                key: "collection.unpaidCaseActionReason.debtorDisputesClaim"
            },
            6: {
                key: "collection.unpaidCaseActionReason.debtorNotReachable"
            },
            7: {
                key: "collection.unpaidCaseActionReason.insolvency"
            },
            8: {
                key: "collection.unpaidCaseActionReason.finalNoticeSentByEmail"
            },
            9: {
                key: "collection.unpaidCaseActionReason.finalNoticeSentByPost"
            },
            10: {
                key: "collection.unpaidCaseActionReason.resubmission"
            },
            11: {
                key: "collection.unpaidCaseActionReason.others"
            },
            13: {
                key: "collection.unpaidCaseActionReason.debtorDoesNotAcceptFactoring"
            },
            14: {
                key: "collection.unpaidCaseActionReason.debtorPromisedToComeBack"
            },
            20: {
                key: "collection.unpaidCaseActionReason.tciBankruptcy"
            },
            21: {
                key: "collection.unpaidCaseActionReason.tciNotPaid"
            },
            22: {
                key: "collection.unpaidCaseActionReason.tciDisputed"
            },
            23: {
                key: "collection.unpaidCaseActionReason.tciRejected"
            },
        }
    },

    disclosedType: {
        Undisclosed: false,
        Disclosed: true,

        properties: {
            false: {
                key: "common.undisclosed"
            },
            true: {
                key: "common.disclosed"
            },
        }
    },

    paymentStatus: {
        Unpaid: 10,
        Paid: 30,
        SettledOtherwise: 40,
        Revoked: 50,

        isSettled(value) {
            return value === this.Paid || value === this.SettledOtherwise;
        }
    },

    assignmentDocumentType: {
        AssignmentContract: 10,
        AdviceOfSettlement: 20,
        ServiceInvoice: 30,
        TransactionPdf: 40,
        AccountingCsv: 50,

        properties: {
            10: {
                key: "common.data.assignmentDocumentType.assignmentContract",
                icon: "fa fa-file-pdf-o"
            },
            20: {
                key: "common.data.assignmentDocumentType.adviceOfSettlement",
                icon: "fa fa-file-pdf-o"
            },
            30: {
                key: "common.data.assignmentDocumentType.serviceInvoice",
                icon: "fa fa-file-pdf-o"
            },
            40: {
                key: "common.data.assignmentDocumentType.transactionPdf",
                icon: "fa fa-file-pdf-o"
            },
            50: {
                key: "common.data.assignmentDocumentType.accountingCsv",
                icon: "fa fa-file-excel-o"
            },
        }
    },

    ipuRequestStatus: {
        Requested: 1,
        Expired: 2,
        Approved: 3,
        Declined: 4,

        properties: {
            1: {
                key: "ipuRequestStatus.requested"
            },
            2: {
                key: "ipuRequestStatus.expired"
            },
            3: {
                key: "ipuRequestStatus.approved"
            },
            4: {
                key: "ipuRequestStatus.declined"
            }
        },

        canBeConfirmed(value) {
            return value === this.Requested;
        }
    },

    filterSchemeType: {
        SellerAllReceivables: 160,
        SellerAllReceivablesRevolvingPutOptions: 162,
        BuyerExchangeReceivables: 210,
        BuyerExchangeRevolvingPutOptions: 212,
        BuyerAllInvestmentsReceivables: 220,
        BuyerAllInvestmentsRevolvingPutOptions: 222
    },

    companyType: {
        TraderCompany: 1,
        PartnerCompany: 2,
        DebtorCompany: 3,
        SystemCompany: 4
    },

    traderType: {
        Supplier: 10,
        Investor: 20,
    },

    companyStatus: {
        Draft: -10,
        New: 0,
        WaitingForDataCheck: 60,
        WaitingForKycCheck: 80,
        Active: 120,
        DebtorVerified: 121,
        Insolvency: -98,
        Disabled: -99,
        Deleted: -100,

        isRegisteredTrader(value) {
            return [this.Active].includes(value);
        },
    },

    debtorSupplierBusinessRelationStatus: {
        Disabled: -99,
        Expired: -20,
        Created: 0,
        Enabled: 100
    },

    userRole: {
        SystemAdmin: 1,
        SystemUser: 2,
        TraderAdmin: 3,
        TraderUser: 4,
        PartnerAdmin: 5,
        PartnerUser: 6,
    },

    ratingStatus: {
        Unknown: 10,
        NotRequested: 20,
        Requested: 30,
        Received: 40,
        MonitoringActive: 50,
        MonitoringStopRequested: 55,
        MonitoringStopped: 60,

        isRatingStatusActive(value) {
            return value === this.Received || value === this.MonitoringActive;
        }
    },

    ratingClass: {
        None: 0,
        Insufficient: 10,
        Low: 20,
        Medium: 30,
        High: 40,

        properties: {
            0: {
                key: "common.ratingClass.none",
            },
            10: {
                key: "common.ratingClass.insufficient",
            },
            20: {
                key: "common.ratingClass.low",
            },
            30: {
                key: "common.ratingClass.medium",
            },
            40: {
                key: "common.ratingClass.high",
            },
        }
    },

    riskCategory: {
        Unknown: 0,
        VeryHigh: 10,
        High: 20,
        Medium: 30,
        Low: 40,

        properties: {
            0: {
                key: "common.riskCategory.unknown",
            },
            10: {
                key: "common.riskCategory.veryHigh",
            },
            20: {
                key: "common.riskCategory.high",
            },
            30: {
                key: "common.riskCategory.medium",
            },
            40: {
                key: "common.riskCategory.low",
            },
        }
    },

    permissions: {
        Dashboard: "TrustBills.Dashboard",
        SellerDebtorManagement: "TrustBills.SellerDebtorManagement",
        SellerInvestorManagement: "TrustBills.UserAccountInfo.Whitelist",
        SellerSellReceivables: "TrustBills.Sell",
        SellerRevolvingPutOptions: "TrustBills.RevolvingPutOptionSeller",
        SellerTrackAndPay: "TrustBills.TrackAndPaySeller",
        SellerManualPayment: "TrustBills.ManualTransfer",
        InvestorExchangeReceivables: "TrustBills.Buy",
        InvestorExchangeAlfa: "TrustBills.Alfa",
        InvestorExchangeRevolvingPutOptions: "TrustBills.RevolvingPutOptionInvestor",
        InvestorCustomRatings: "TrustBills.CustomRatings",
        DebtorIpuConfirmations: "TrustBills.ReceivableVerifByObligor",
        DebtorTrackAndPay: "TrustBills.TrackAndPayDebtor",
        AdminProfile: "TrustBills.UserAccountInfo.UserProfile",
        AdminUserManagement: "TrustBills.TraderTeam",
        AdminCompany: "TrustBills.UserAccountInfo.Manager",
        AdminBankAccountManagement: "TrustBills.UserAccountInfo.SubAccountManage",
        AdminInvoiceManagement: "TrustBills.BillOrder",

        properties: {
            "TrustBills.RevolvingPutOptionSeller": {
                missingPermissionTooltipKey: {
                    adminUser: "revolvingPutOption.permissionRequired.supplier.tooltip.adminUser"
                }
            },
            "TrustBills.RevolvingPutOptionInvestor": {
                missingPermissionTooltipKey: {
                    adminUser: "revolvingPutOption.permissionRequired.investor.tooltip.adminUser"
                }
            }
        },
    },

    revolvingPutOptionStatus: {
        New: 0,
        Published: 10,
        Expired: 20,
        ReadyToBeAccepted: 30,
        Accepted: 40,
        Running: 50,
        Finished: 60,
        ExpiredArchive: -20,
        WithdrawnArchive: -50,
        /*CanceledOrdinary: -100,*/ // Deprecated with DEV-3519
        CanceledExtraordinary: -120,

        properties: {
            0: {
                key: "common.revolvingPutOptionStatus.created"
            },
            10: {
                key: "common.revolvingPutOptionStatus.published"
            },
            20: {
                key: "common.revolvingPutOptionStatus.expired"
            },
            30: {
                key: "common.revolvingPutOptionStatus.readyToBeAccepted"
            },
            40: {
                key: "common.revolvingPutOptionStatus.accepted"
            },
            50: {
                key: "common.revolvingPutOptionStatus.running"
            },
            60: {
                key: "common.revolvingPutOptionStatus.finished"
            },
            "-20": {
                key: "common.revolvingPutOptionStatus.expiredArchive"
            },
            "-50": {
                key: "common.revolvingPutOptionStatus.withdrawnArchive"
            },
            /*"-100": { key: "common.revolvingPutOptionStatus.canceledOrdinary" },*/ // Deprecated with DEV-3519
            "-120": {
                key: "common.revolvingPutOptionStatus.canceledExtraordinary"
            },
        },

        isNewOrExpired(status) {
            return status === this.New || status === this.Expired;
        },

        isPublishedOrReadyToBeAccepted(status) {
            return status === this.Published || status === this.ReadyToBeAccepted;
        },

        isAcceptedOrRunning(status) {
            return status === this.Accepted || status === this.Running;
        },

        isUnaccepted(status) {
            return [this.New, this.Published, this.Expired, this.ReadyToBeAccepted].includes(Number(status));
        },

        isArchived(status) {
            return [this.ExpiredArchive, this.WithdrawnArchive].includes(Number(status));
        }
    },

    paymentExecutionType: {
        Automatic: 0,
        Manual: 10
    },

    genderType: {
        Female: 1,
        Male: 2,

        properties: {
            1: {
                key: "common.gender.female"
            },
            2: {
                key: "common.gender.male"
            }
        }
    },

    signUpStepGroup: {
        Start: 10,
        Company: 20,
        MasterUser: 30,
        Kyc: 40,
        Overview: 50
    },

    signUpStep: {
        Language: 10,
        // Invitation: 20,
        Company: 30,
        LegalData: 40,
        BankAccount: 50,
        MasterUser: 60,
        RepresentativeUser: 70,
        Representatives: 80,
        BeneficialOwners: 90,
        Password: 100,
        Overview: 110,
        Completion: 120,

        properties: {
            10: {
                order: 1,
                path: navigationPaths.register.language
            },
            // 20: {
            //     order: 2,
            //     path: navigationPaths.register.invitation
            // },
            30: {
                order: 3,
                path: navigationPaths.register.company
            },
            40: {
                order: 4,
                path: navigationPaths.register.legalData
            },
            50: {
                order: 5,
                path: navigationPaths.register.bankAccount
            },
            60: {
                order: 6,
                path: navigationPaths.register.masterUser
            },
            70: {
                order: 7,
                path: navigationPaths.register.representativeUser
            },
            80: {
                order: 8,
                path: navigationPaths.register.representatives
            },
            90: {
                order: 9,
                path: navigationPaths.register.beneficialOwners
            },
            100: {
                order: 10,
                path: navigationPaths.register.password
            },
            110: {
                order: 11,
                path: navigationPaths.register.overview
            },
            120: {
                order: null,
                path: navigationPaths.register.completion
            }
        },

        parentGroup(step) {
            switch (step) {
                case this.Language:
                // case this.Invitation:
                    return enumDef.signUpStepGroup.Start;
                case this.Company:
                case this.LegalData:
                case this.BankAccount:
                    return enumDef.signUpStepGroup.Company;
                case this.MasterUser:
                    return enumDef.signUpStepGroup.MasterUser;
                case this.RepresentativeUser:
                case this.Representatives:
                case this.BeneficialOwners:
                    return enumDef.signUpStepGroup.Kyc;
                case this.Password:
                case this.Overview:
                    return enumDef.signUpStepGroup.Overview;
                default:
                    return null;
            }
        },

        orderedList() {
            return Object.keys(this.properties)
                .filter(stepKey => this.properties[stepKey].order !== null)
                .sort((stepKey1, stepKey2) => this.properties[stepKey1].order - this.properties[stepKey2].order)
                .map(stepKey => parseInt(stepKey));
        },

        path(step) {
            return this.properties[step].path;
        },

        forPath(path) {
            let stepKeyForPath = Object.keys(this.properties).find(stepKey => this.properties[stepKey].path === path);
            return parseInt(stepKeyForPath);
        },
    },

    trafficLight: {
        Red: 0,
        Yellow: 1,
        Green: 2,
        properties: {
            0: {
                iconName: "fa-circle",
                colorName: "invalid_color"
            },
            1: {
                iconName: "fa-circle",
                colorName: "warn_color",
            },
            2: {
                iconName: "fa-circle",
                colorName: "valid_color",
            }
        }
    },

    trackPayStats: {
        New: 10,
        Submitted: 20,
        Confirmed: 30,
        Rejected: 40,
        Transferred: 50,
        SentToExternal: 60,
        AllDevicesBound: 65,
        Tracking: 70,
        Arrived: 80,
        Settled: 90,
        Cancelled: -10,
        properties: {
            10: {
                key: "trackPay.shipmentProgressStatus.new",
                nextStepKey: 'trackPay.supplier.scheduled.1'
            },
            20: {
                key: "trackPay.shipmentProgressStatus.submitted",
                nextStepKey: 'trackPay.supplier.scheduled.2',
                debtorStatusKey: 'trackPay.debtorContractsTable.scheduled.1'
            },
            30: {
                key: "common.data.debtor.contractsStatus.confirmed",
                nextStepKey: 'trackPay.supplier.scheduled.3',
                debtorStatusKey: 'trackPay.debtorContractsTable.scheduled.2'
            },
            40: {
                key: "trackPay.shipmentProgressStatus.rejected",
                nextStepKey: 'trackPay.supplier.scheduled.1',
                debtorStatusKey: 'trackPay.debtorContractsTable.scheduled.1'
            },
            50: {
                key: "trackPay.shipmentProgressStatus.transferComplete",
                nextStepKey: 'trackPay.supplier.scheduled.3',
                debtorStatusKey: 'trackPay.debtorContractsTable.scheduled.3'
            },
            60: {
                key: "trackPay.shipmentProgressStatus.sent",
                nextStepKey: 'trackPay.supplier.scheduled.4',
                debtorStatusKey: 'trackPay.debtorContractsTable.scheduled.4'
            },
            65: {
                key: "trackPay.shipmentProgressStatus.sent",
                nextStepKey: 'trackPay.supplier.scheduled.4',
                debtorStatusKey: 'trackPay.debtorContractsTable.scheduled.4'
            },
            70: {
                key: "trackPay.shipmentProgressStatus.tracked",
                nextStepKey: 'trackPay.supplier.scheduled.5',
                debtorStatusKey: 'trackPay.debtorContractsTable.scheduled.4'
            },
            80: {
                key: "trackPay.shipmentProgressStatus.arrived",
                nextStepKey: 'trackPay.supplier.scheduled.6',
                debtorStatusKey: 'trackPay.debtorContractsTable.scheduled.5'
            },
            90: {
                key: "trackPay.shipmentProgressStatus.settled",
                debtorStatusKey: 'trackPay.debtorContractsTable.scheduled.6'
            }
        }
    },

    obligatory: {
        Debtor: 1,
        Supplier: 2,
        properties: {
            1: {
                key: "common.debtor"
            },
            2: {
                key: "common.supplier"
            }
        }
    },

    creditInsurancePolicyHolderStatus: {
        NONE: 0,
        REQUESTED: 10,
        ACCEPTED: 20,
        REJECTED: 30,

        canBuyTci(status) {
            return status === this.ACCEPTED;
        },
        hasRequestedAccess(status) {
            return status === this.REQUESTED;
        },
        hasTciAccess(status) {
            return this.canBuyTci(status) || this.hasRequestedAccess(status);
        }
    },

    modeOfTransport: {
        AIR_FREIGHT: "trackPay.contractsEditModal.modeOfTransport.air",
        SEA_FREIGHT: "trackPay.contractsEditModal.modeOfTransport.sea",
        INLAND_SHIPPING: "trackPay.contractsEditModal.modeOfTransport.inland",
        RAIL_FREIGHT: "trackPay.contractsEditModal.modeOfTransport.rail",
        ROAD_FREIGHT: "trackPay.contractsEditModal.modeOfTransport.road"
    },

    alfaFilterType: {
        Is: "IS",
        IsNot: "IS_NOT",
        IsMax: "IS_MAX",
        IsMin: "IS_MIN",
        IsBetween: "IS_BETWEEN",

        properties: {
            "IS": {
                key: "common.alfa.filterType.is"
            },
            "IS_NOT": {
                key: "common.alfa.filterType.isNot"
            },
            "IS_MAX": {
                key: "common.alfa.filterType.max"
            },
            "IS_MIN": {
                key: "common.alfa.filterType.min"
            },
            "IS_BETWEEN": {
                key: "common.alfa.filterType.between"
            }
        },

        isNumeric(filterType) {
            return [this.IsMin, this.IsMax, this.IsBetween].includes(filterType);
        },

        isList(filterType) {
            return [this.Is, this.IsNot].includes(filterType);
        }
    },

    alfaValueType: {
        Number: "NUMBER",
        PercentageRate: "PERCENTAGE_RATE",
        AssignmentType: "ASSIGNMENT_TYPE",
        RiskCategory: "RISK_CATEGORY",
        DebtorCompany: "DEBTOR_COMPANY",
        DebtorCountry: "DEBTOR_COUNTRY",
        SellerCompany: "SELLER_COMPANY",
        SellerCountry: "SELLER_COUNTRY",
        Industry: "INDUSTRY",
    },

    alfaSettingsStatus: {
        NotActive: 0,
        Active: 10,
        ModifiedArchived: -10
    },

    alfaBuyPreference: {
        Never: 0,
        Preferred: 10,
        Only: 20,
    },

    SellDurationOptions: {
        ONE: 1,
        THREE: 3,
        SEVEN: 7,
        properties: {
            1: { value: 24, key: "common.offerDuration.1day" },
            3: { value: 72, key: "common.offerDuration.3days" },
            7: { value: 168, key: "common.offerDuration.7days" }
        },
        default: 7
    },

    nowAdjustment: { value: 5, unit: "m" },

    noAccessDisplayType: {
        Lock: "lock",
        Hide: "hide"
    },

    sellPriceCalculationType: {
        None: 0,
        Discount: 10,
        CostOfCapital: 20,
    },

    sellPriceSource: {
        None: 0,
        Predefined: 10,
        User: 20
    }
};
export {
    enumDef
};